angular.module('rjmNg.directives').directive 'freeTrialBanner', () ->
  restrict: 'E'
  templateUrl:  "directive.freeTrialBanner.html"
  replace: true
  scope: {}
  bindToController: true
  controllerAs: 'view'
  controller: [
    "Clients"
    "Billing"
    "app"
    "FEATURE_TIER"
    (
      Clients
      Billing
      app
      FEATURE_TIER
    ) ->
      view = @
      view.showBanner = false
      view.clientId = app.getClientId()
      view.countdownDays = 0

      _isEssentialsClient = (clientInfo) ->
        clientInfo.properties?.feature_tier is FEATURE_TIER.BASIC.toString()

      _hasMagentoSubscriptionId = (clientInfo) ->
        clientInfo.properties.magento_subscription_id? and
          clientInfo?.properties?.magento_subscription_id isnt ""

      _showFreeTrialCountdownIfApplicable = () ->
        Billing.getSubscriptionStatus(view.clientId)
        .then ({free_trial}) ->
          {days_remaining} = free_trial
          view.countdownDays = days_remaining

          if days_remaining <= 3 and days_remaining > 0
            view.showBanner = true

      @$onInit = () ->
        Clients.get(view.clientId)
        .then (clientInfo) ->
          # EE/ECE/MOM clients get essentials for free so don't show the banner for them
          if _isEssentialsClient(clientInfo) and
            _hasMagentoSubscriptionId(clientInfo) and
            not app.isBillingExempt()
              _showFreeTrialCountdownIfApplicable()
        .catch () ->

      view
  ]
